export const getQueryParams = (): Record<string, string> => {
  const queryString = window.location.search.substring(1)
  const params: Record<string, string> = {}
  const queries = queryString.split('&')
  queries.forEach((indexQuery) => {
    const indexPair = indexQuery.split('=')

    const queryKey = decodeURIComponent(indexPair[0]).toLowerCase()
    const queryValue = decodeURIComponent(indexPair.length > 1 ? indexPair[1] : '')

    params[queryKey] = queryValue
  })
  return params
}
